import { apiGet, apiPatch } from './client';
import type { TradeMarket, TradeMarketBatchRequest } from '../types/TradeMarket';

export function getTradeMarkets(): Promise<TradeMarket[]> {
  return apiGet<TradeMarket[]>('/api/trade-markets');
}

export function saveBatchTradeMarkets(
  added: TradeMarket[],
  modified: TradeMarket[],
  deletedIds: number[],
): Promise<TradeMarket[]> {
  return apiPatch<TradeMarketBatchRequest, TradeMarket[]>(
    '/api/trade-markets/batch',
    { added, modified, deleted: deletedIds },
  );
}
